<!--
 * @Descripttion: 场景价格管理
 * @Date: 2026-07-02 10:00:00
-->
<template>
  <div class="scene-price-mgmt-list">
    <xrk-table
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { formatter } from '@/utils/';
import { listPage } from '../data-source/apis';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

const router = useRouter();

// 搜索项
const searchConfig: XrkTableProps['searchConfig'] = {
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [] as any[],
  otherComponents: []
};

// 列表
const tableConfig: XrkTableProps['tableConfig'] = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: 80
    }),
    useTableColumn({
      label: '工业名称',
      prop: 'industryName',
      minWidth: 260
    }),
    useTableColumn({
      label: '已开通场景数',
      prop: 'activatedSceneCount',
      align: 'right'
    }),
    useTableColumn({
      label: '最近更新时间',
      prop: 'updateAt',
      minWidth: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 120,
      render: ({ row }) => {
        return (
          <BaseButton
            link
            type="primary2"
            onClick={() => {
              router.push({
                path: '/main/industry/scene-price-mgmt/config',
                query: {
                  industry: row.industryName,
                  industryId: String(row.industryId)
                }
              });
            }}
          >
            配置价格
          </BaseButton>
        );
      }
    })
  ] as any[]
};
const { info } = storeToRefs(appStore.useUserStoreSetup);

const getListAjax = async (params: Record<string, any>) => {
  return await listPage({ ...params, industryId: info.value.finalDepId });
};
</script>
<style lang="scss" scoped>
.notice-bar {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  padding: 10px 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.6;
}
.notice-bar strong {
  color: #374151;
}
</style>
